module.exports = __webpack_public_path__ + "static/treasure-map-812a8880b1df12759c012ef7a0a84b8e.svg";